AFRAME.registerComponent('tradingview-universal-chart', {
    schema: {
        intervals: { type: 'number', default: 200 },
        multiplier: { type: 'string', default: '14' },
        timespan: { type: 'string', default: 'day' },
        startDate: { type: 'string', default: '' },
        endDate: { type: 'string', default: '' },
        stockData: { type: 'string', default: '' },
        dataInterval: { type: 'string', default: '1d' },
        candlestickSpacing: { type: 'number', default: 0.01 },
        width: { type: 'number', default: 500 },
        height: { type: 'number', default: 480 },
        scale: { type: 'string', default: '11 11 11' },
        position: { type: 'string', default: '0 0 0' },
        type: { type: 'string', default: 'mountain', oneOf: ['mountain', 'candlestick', 'line'] },
        volumeHeight: { type: 'number', default: 0.3 },
        paneGap: { type: 'number', default: 0.2 },
        chartMathFunction: { type: 'string', default: 'Linear', oneOf: ['Log', 'Linear'] },
        showExtendedHours: { type: 'boolean', default: false },
        showEvents: { type: 'boolean', default: false },
        isETTimeZone: { type: 'boolean', default: true },
        secondarySeriesType: { type: 'string', default: 'volume', oneOf: ['volume', 'dividend', 'sip'] },
        isSearchMode: { type: 'boolean', default: false },
    },

    init: async function () {
        console.log('[TradingView Universal VR] Initializing v2 component');

        this.popupOpenedTime = 0;
        this.applyDataFromStorage();

        const noSelectedStockPopup = document.querySelector('#no-selected-stock-message');
        const stockWrapper = document.querySelector('#stock-wrapper');
        if (noSelectedStockPopup) {
            noSelectedStockPopup.setAttribute('visible', 'false');
        }
        if (stockWrapper) {
            stockWrapper.setAttribute('visible', 'true');
        }

        this.dataIntervalListener = (event) => {
            const { interval } = event.detail;
            this.el.setAttribute('tradingview-universal-chart', 'dataInterval', interval.toLowerCase());
        };
        this.el.sceneEl.addEventListener('data-interval', this.dataIntervalListener);

        this.timelineDataListener = (event) => this.handleTimelineData(event);
        this.el.sceneEl.addEventListener('timeline-data', this.timelineDataListener);

        this.timezoneListener = (event) => {
            if (!event || !event.detail || typeof event.detail.isETTimeZone !== 'boolean') return;
            const newTZ = event.detail.isETTimeZone;
            if (newTZ !== this.data.isETTimeZone) {
                this.el.setAttribute('tradingview-universal-chart', 'isETTimeZone', newTZ);
            }
        };
        document.addEventListener('timezone-changed', this.timezoneListener);

        if (typeof LiveChartAPIManager === 'undefined') {
            console.error('[TradingView Universal VR] LiveChartAPIManager not found.');
            return;
        }

        if (typeof window.TradingViewCore === 'undefined') {
            console.error('[TradingView Universal VR] TradingViewCore not found.');
            return;
        }

        this.core = new window.TradingViewCore(this.el, document.body, this.data);

        this.core.refreshHtmlMesh = () => this.refreshHtmlMesh();
        this.core.setPointerListener = () => { };

        const origUpdateTitle = this.core.updateChartTitle.bind(this.core);
        this.core.updateChartTitle = () => {
            origUpdateTitle();
            const nameEl = this.core.chartHeaderCompanyName;
            if (nameEl) {
                const ticker = this.core.ticker || 'SPY';
                const stockMeta = this.core.stockMeta;
                let companyName = stockMeta?.tickerDetails?.name || stockMeta?.tickerSummary?.name || ticker;

                if (companyName.length > 30) {
                    companyName = companyName.substring(0, 30) + '...';
                    const exchange = stockMeta?.tickerDetails?.primary_exchange || stockMeta?.tickerSummary?.primary_exchange || '';
                    const exchangeAbbr = this.core.formatExchangeAbbreviation(exchange);
                    const exchangeTicker = exchangeAbbr ? `(${exchangeAbbr}:${ticker})` : `(${ticker})`;
                    nameEl.textContent = `${companyName} ${exchangeTicker}`;
                }
            }
            this.refreshHtmlMesh();
        };

        const origThemeToContainer = this.core.applyThemeToContainer.bind(this.core);
        this.core.applyThemeToContainer = () => {
            origThemeToContainer();
            const isLight = document.body.classList.contains('light') || document.body.classList.contains('cb-light');
            if (this.chartHoverPopup) {
                if (isLight) {
                    this.chartHoverPopup.style.background = '#ffffff';
                    this.chartHoverPopup.style.color = '#000000';
                    this.chartHoverPopup.style.borderColor = '#cccccc';
                } else {
                    this.chartHoverPopup.style.background = '#000000';
                    this.chartHoverPopup.style.color = '#ffffff';
                    this.chartHoverPopup.style.borderColor = '#333333';
                }
            }
        };

        const origRebuildChart = this.core.rebuildChart.bind(this.core);
        this.core.rebuildChart = () => {
            origRebuildChart();
        };

        await this.core.init();
        this.createHTMLMeshAndAdjustContainer();

        this.sceneClickListener = (event) => {
            if (this.popupOpenedTime && Date.now() - this.popupOpenedTime < 150) {
                return;
            }
            const clickedEl = event.target;
            if (this.htmlMesh && clickedEl !== this.htmlMesh) {
                if (this.chartHoverPopup && this.chartHoverPopup.style.display !== 'none') {
                    this.chartHoverPopup.style.display = 'none';
                    this.triggerMeshUpdate();
                }
            }
        };
        this.el.sceneEl.addEventListener('click', this.sceneClickListener);
        this.el.sceneEl.addEventListener('mousedown', this.sceneClickListener);
    },

    createHTMLMeshAndAdjustContainer: function () {
        if (!this.core.chartContainer) return;

        this.core.chartContainer.style.position = 'absolute';
        this.core.chartContainer.style.zIndex = '-9999';
        this.core.chartContainer.style.top = '0px';
        this.core.chartContainer.style.left = '0px';

        // Add the VR specific hover popup
        this.chartHoverPopup = document.createElement('div');
        this.chartHoverPopup.className = 'right-chart-hover-popup';
        this.chartHoverPopup.style.cssText = `
            position: absolute;
            background: rgba(0, 0, 0, 0.9);
            color: #d1d4dc;
            padding: 8px;
            border-radius: 4px;
            font-size: 15px;
            pointer-events: none;
            display: none;
            flex-direction: column;
            gap: 5px;
            z-index: 1000;
            border: 1px solid #333;
            box-shadow: 0 4px 6px rgba(0,0,0,0.3);
            transform: translateZ(0);
        `;
        this.core.chartContainer.appendChild(this.chartHoverPopup);

        this.htmlMesh = document.createElement('a-entity');
        this.htmlMesh.setAttribute('html', {
            html: `#${this.core.chartContainer.id}`,
            cursor: 'default'
        });
        this.htmlMesh.setAttribute('position', this.data.position);
        this.htmlMesh.setAttribute('scale', this.data.scale);
        this.htmlMesh.setAttribute('class', 'clickable');
        this.htmlMesh.setAttribute('data-raycastable', '');

        this.el.appendChild(this.htmlMesh);

        this.clickListener = (e) => this.handleVrClick(e);
        this.htmlMesh.addEventListener('click', this.clickListener);
        this.htmlMesh.addEventListener('mousedown', this.clickListener);

        this.refreshHtmlMesh();
    },

    applyDataFromStorage: function () {
        if (typeof getCacheItem === 'function') {
            try {
                const popupSettings = getCacheItem('rightConfigurePopupSettings');
                if (popupSettings) {
                    if (this.data.type !== popupSettings.chartType && typeof popupSettings.chartType === 'string') {
                        this.data.type = popupSettings.chartType.toLowerCase();
                    }
                    if (this.data.showEvents !== popupSettings.showEvents && typeof popupSettings.showEvents === 'boolean') {
                        this.data.showEvents = popupSettings.showEvents;
                    }
                }
            } catch (e) {
                console.warn('[TradingView Universal] Failed to read from popup settings');
            }
        }
    },

    refreshHtmlMesh: function () {
        setTimeout(() => {
            if (this.core && this.core.chartContainer) {
                this.core.chartContainer.classList.add('chart-updating-' + Date.now());
            }
        }, 200);

        if (this.htmlMesh && this.htmlMesh.components.html) {
            const htmlComponent = this.htmlMesh.components.html;
            if (htmlComponent.forceRender) htmlComponent.forceRender();
        }
    },

    triggerMeshUpdate: function () {
        if (this.core && this.core.chartContainer) {
            const current = this.core.chartContainer.getAttribute('data-update-toggle') || '0';
            this.core.chartContainer.setAttribute('data-update-toggle', current === '0' ? '1' : '0');
        }
    },

    handleVrClick: function (evt) {
        if (!this.core || !this.core.chart || !evt.detail || !evt.detail.intersection || !evt.detail.intersection.uv) return;

        const uv = evt.detail.intersection.uv;
        const width = this.data.width;
        const height = this.data.height;
        const x = uv.x * width;
        const y = (1 - uv.y) * height;

        const timeScale = this.core.chart.timeScale();
        const time = timeScale.coordinateToTime(x);

        if (!time) {
            if (this.chartHoverPopup) this.chartHoverPopup.style.display = 'none';
            this.triggerMeshUpdate();
            return;
        }

        let foundPoint = null;
        const pointsToSearch = this.core.stockPoints;

        if (pointsToSearch && pointsToSearch.length > 0) {
            foundPoint = pointsToSearch.find(p => {
                if (p.t) {
                    const timestampSeconds = Math.floor(p.t / 1000);
                    if (typeof time === 'number') return timestampSeconds === time;
                    if (time && time.year) {
                        const dateFromTimestamp = new Date(p.t);
                        return dateFromTimestamp.getFullYear() === time.year &&
                            (dateFromTimestamp.getMonth() + 1) === time.month &&
                            dateFromTimestamp.getDate() === time.day;
                    }
                }
                if (p.time) {
                    if (typeof p.time === 'number' && typeof time === 'number') return p.time === time;
                    if (p.time.year && time && time.year) {
                        return p.time.year === time.year && p.time.month === time.month && p.time.day === time.day;
                    }
                }
                if (p.DateTime) {
                    const date = new Date(p.DateTime);
                    const timestamp = date.getTime() / 1000;
                    if (typeof time === 'number') return timestamp === time;
                    if (time && time.year) {
                        return date.getFullYear() === time.year &&
                            (date.getMonth() + 1) === time.month &&
                            date.getDate() === time.day;
                    }
                }
                return false;
            });

            if (!foundPoint && typeof time === 'number') {
                const closest = pointsToSearch.reduce((prev, curr) => {
                    const prevTime = prev.t ? Math.floor(prev.t / 1000) : (typeof prev.time === 'number' ? prev.time : 0);
                    const currTime = curr.t ? Math.floor(curr.t / 1000) : (typeof curr.time === 'number' ? curr.time : 0);
                    return (Math.abs(currTime - time) < Math.abs(prevTime - time) ? curr : prev);
                });

                const closestTime = closest.t ? Math.floor(closest.t / 1000) : (typeof closest.time === 'number' ? closest.time : 0);
                if (Math.abs(closestTime - time) < 3600 * 24) {
                    foundPoint = closest;
                }
            }
        }

        if (!foundPoint) {
            if (this.chartHoverPopup) this.chartHoverPopup.style.display = 'none';
            this.triggerMeshUpdate();
            return;
        }

        this.updatePopupContent(foundPoint, { x, y });
    },

    updatePopupContent: function (point, coords) {
        if (!this.chartHoverPopup) return;

        this.popupOpenedTime = Date.now();
        this.chartHoverPopup.style.display = 'flex';
        this.chartHoverPopup.innerHTML = '';

        let dateStr = '';
        const dateOptions = { month: 'numeric', day: 'numeric', year: '2-digit', hour: 'numeric', minute: '2-digit', hour12: true, timeZone: 'UTC' };

        if (point.t) dateStr = new Date(point.t).toLocaleString('en-US', dateOptions);
        else if (point.DateTime) dateStr = new Date(point.DateTime).toLocaleString('en-US', dateOptions);
        else if (point.time) {
            if (typeof point.time === 'number') dateStr = new Date(point.time * 1000).toLocaleString('en-US', dateOptions);
            else if (point.time.year) dateStr = new Date(Date.UTC(point.time.year, point.time.month - 1, point.time.day)).toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: '2-digit' });
        }

        if (dateStr) this.chartHoverPopup.innerHTML += `<div style="text-align:center; color: #888; margin-bottom:4px;">${dateStr}</div>`;

        let priceValue;
        if (point.Close !== undefined) priceValue = parseFloat(point.Close);
        else if (point.c !== undefined) priceValue = parseFloat(point.c);
        else if (point.value !== undefined) {
            if (typeof point.value === 'number') priceValue = point.value;
            else if (typeof point.value === 'object' && point.value.close) priceValue = parseFloat(point.value.close);
        }

        const formattedPrice = isFinite(priceValue) ? priceValue.toFixed(2) : '0.00';
        this.chartHoverPopup.innerHTML += `<div>Price: ${formattedPrice}</div>`;

        const secondaryType = this.data.secondarySeriesType || 'volume';

        if (secondaryType === 'dividend' && this.core.stockDividendData) {
            let dividendInfo = null;
            const pointTime = point.t ? point.t : (point.DateTime ? new Date(point.DateTime).getTime() : null);
            if (pointTime) {
                dividendInfo = this.core.stockDividendData.find(d => {
                    const dTime = new Date(d.pay_date || d.ex_dividend_date).getTime();
                    return Math.abs(dTime - pointTime) < 86400 * 1000;
                });
            }
            if (dividendInfo && dividendInfo.cash_amount) this.chartHoverPopup.innerHTML += `<div>Dividend: $${dividendInfo.cash_amount.toFixed(2)}</div>`;
        } else if (secondaryType === 'sip' && this.core.stockShortInterestData) {
            let sipInfo = null;
            const pointTime = point.t ? point.t : (point.DateTime ? new Date(point.DateTime).getTime() : null);
            if (pointTime) {
                sipInfo = this.core.stockShortInterestData.find(d => {
                    const dTime = new Date(d.settlement_date).getTime();
                    return Math.abs(dTime - pointTime) < 86400 * 1000;
                });
            }
            if (sipInfo && sipInfo.short_interest) this.chartHoverPopup.innerHTML += `<div>Short Interest: ${this.core.prettifyNumber(sipInfo.short_interest)}</div>`;
        } else {
            let vol;
            if (point.Volume !== undefined) vol = point.Volume;
            else if (point.v !== undefined) vol = point.v;
            else if (point.volume !== undefined) vol = point.volume;
            if (vol !== undefined) this.chartHoverPopup.innerHTML += `<div>Volume: ${this.core.prettifyNumber(vol)}</div>`;
        }

        const containerWidth = (this.core && this.core.chartContainer) ? this.core.chartContainer.clientWidth : this.data.width;
        const containerHeight = (this.core && this.core.chartContainer) ? this.core.chartContainer.clientHeight : this.data.height;
        const popupWidth = 165;
        const popupHeight = this.chartHoverPopup.offsetHeight || 100;

        let leftPos = coords.x + 10;
        if (leftPos + popupWidth > containerWidth) leftPos = coords.x - popupWidth - 10;
        this.chartHoverPopup.style.left = leftPos + 'px';

        let topPos = coords.y;
        if (topPos + popupHeight > containerHeight) {
            topPos = coords.y - popupHeight;
            if (topPos < 0) topPos = 0;
        }
        this.chartHoverPopup.style.top = topPos + 'px';

        setTimeout(() => this.triggerMeshUpdate(), 50);
    },

    handleTimelineData: async function (event) {
        if (!this.core) return;
        const { timestamps } = event.detail;
        if (!timestamps || timestamps.length === 0) return;

        const dataInterval = this.data.dataInterval?.toLowerCase() || '1d';
        if (dataInterval === '1d') return;

        let startDate = timestamps[0].includes(' ') ? timestamps[0].split(' ')[0] : (timestamps[0].includes('T') ? timestamps[0].split('T')[0] : timestamps[0]);
        let endDateObj = new Date(timestamps[timestamps.length - 1].includes(' ') ? timestamps[timestamps.length - 1].split(' ')[0] : (timestamps[timestamps.length - 1].includes('T') ? timestamps[timestamps.length - 1].split('T')[0] : timestamps[timestamps.length - 1]));

        endDateObj.setDate(endDateObj.getDate() + 5);

        const oldData = Object.assign({}, this.data, { startDate: 'trigger_fetch' });
        this.data.startDate = startDate;
        this.data.endDate = endDateObj.toISOString().split('T')[0];

        await this.update(oldData);
    },

    update: async function (oldData) {
        if (!this.core) return;
        this.core.config = this.data;

        if (this.chartHoverPopup) {
            this.chartHoverPopup.style.display = 'none';
        }

        if (this.htmlMesh) {
            if (this.data.position !== oldData.position) {
                const position = this.data.position.split(' ').map(parseFloat);
                this.htmlMesh.setAttribute('position', `${position[0]} ${position[1]} ${position[2]}`);
            }
            if (this.data.scale !== oldData.scale) {
                const scale = this.data.scale.split(' ').map(parseFloat);
                this.htmlMesh.setAttribute('scale', `${scale[0]} ${scale[1]} ${scale[2]}`);
            }
        }
        this.updateSizeAndPosition();

        await this.core.update(oldData);
    },

    updateSizeAndPosition: function () {
        const stockMeta = this.data.stockData ? JSON.parse(this.data.stockData) : {};
        const ticker = stockMeta.ticker || 'SPY';
        const shortView = this.data.dataInterval === '1d' && ticker !== 'SPY';
        
        let newWidth, newHeight, newPosition;
        if (this.data.isSearchMode) {
            newWidth = shortView ? 600 : 700;
            newHeight = 450;
            newPosition = shortView ? '-0.35 0 0' : '-0.9 0 0';
        } else {
            newWidth = shortView ? 500 : 640;
            newHeight = 480;
            newPosition = shortView ? '0 0 -0.48' : '-0.8 0 -0.48';
        }

        if (this.data.width === newWidth && this.data.height === newHeight && this.data.position === newPosition) return;

        this.core.config.width = newWidth;
        this.core.config.height = newHeight;
        this.el.setAttribute('tradingview-universal-chart', 'position', newPosition);

        if (!this.core.chartContainer) return;

        if (this.core.chartContainer && this.core.chartContainer.parentNode) {
            try { this.core.chartContainer.parentNode.removeChild(this.core.chartContainer); } catch (e) { }
            this.core.chartContainer = null;
        }
        this.core.createChartContainer();

        if (this.htmlMesh && this.htmlMesh.parentNode) {
            try { this.htmlMesh.parentNode.removeChild(this.htmlMesh); } catch (e) { }
            this.htmlMesh = null;
        }
        this.createHTMLMeshAndAdjustContainer();

        this.core.rebuildChart();
    },

    remove: function () {
        console.log('[TradingView Universal VR] Component being removed');

        if (this.sceneClickListener) {
            this.el.sceneEl.removeEventListener('click', this.sceneClickListener);
            this.el.sceneEl.removeEventListener('mousedown', this.sceneClickListener);
            this.sceneClickListener = null;
        }

        if (this.htmlMesh && this.htmlMesh.parentNode) {
            try { this.htmlMesh.parentNode.removeChild(this.htmlMesh); } catch (e) { }
            this.htmlMesh = null;
        }

        if (this.dataIntervalListener) {
            this.el.sceneEl.removeEventListener('data-interval', this.dataIntervalListener);
            this.dataIntervalListener = null;
        }

        if (this.timelineDataListener) {
            this.el.sceneEl.removeEventListener('timeline-data', this.timelineDataListener);
            this.timelineDataListener = null;
        }

        if (this.timezoneListener) {
            document.removeEventListener('timezone-changed', this.timezoneListener);
            this.timezoneListener = null;
        }

        if (this.clickListener && this.htmlMesh) {
            this.htmlMesh.removeEventListener('click', this.clickListener);
            this.htmlMesh.removeEventListener('mousedown', this.clickListener);
        }

        if (this.core) {
            this.core.remove(); // Core handles removing chartContainer from DOM
            this.core = null;
        }
    }
});

console.log('[TradingView Universal VR] Component registered successfully');
